import React, {useEffect, useState, useContext} from "react"
import Column from "@amzn/meridian/column"
import Row from "@amzn/meridian/row";
import RadioButton from "@amzn/meridian/radio-button"
import {ReceiveGroupByContext} from "./context/ReceiveGroupByContext";
import {FormattedMessage, injectIntl} from "react-intl";
import Box from "@amzn/meridian/box";
import Link from "@amzn/meridian/link";
import Tag from "@amzn/meridian/tag";
import {getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {parseCapabilitiesResponse} from "../util/Util";

const ReceiveGroupBy = ({ intl }) => {
    const { groups, dispatch } = useContext(ReceiveGroupByContext)
    const [ filterState, setFilterState ] = useState(false);

    useEffect(() => {
        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = parseCapabilitiesResponse(capabilityResponse)
            dispatch({ type: 'INITIALIZE_GROUPS', capability});
        })
    }, []);

    const toggleFilter = () => {
        setFilterState(!filterState);
    };

    return (
        <Column>
            <Row width="100%" spacingInset="large large none large">
                <Box>
                    <Link href="" type="secondary" onClick={toggleFilter}>
                        <FormattedMessage id="receive.filter.title" defaultMessage="Options"/>
                    </Link>
                </Box>
                <Box>
                    <div className="filter-tag">
                        <Tag key = {groups.selectedGroup.value} type="neutral">
                            {groups.selectedGroup.displayName}
                        </Tag>
                    </div>
                </Box>
            </Row>
            {filterState ? <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                {groups.allGroups.map(group => {
                    return <RadioButton key={group.value} value={group}
                                        checked={groups.selectedGroup.value === group.value}
                                        onChange={(data) => dispatch({ type: 'SELECT_GROUP', selectedGroup: data })}>
                        {group.displayName}
                    </RadioButton>
                })}
            </Row> : null}
        </Column>
    )
}

export default injectIntl(ReceiveGroupBy);


// WEBPACK FOOTER //
// ./src/components/receive/ReceiveGroupBy.js